var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0874 1.77577C23.868 -0.949634 19.1267 -0.427748 16.1414 2.5876L15.0293 3.74734L13.8586 2.5876C10.9318 -0.427748 6.13199 -0.949634 2.91258 1.77577C-0.775107 4.90709 -0.950712 10.4739 2.32723 13.8371L13.683 25.4346C14.3854 26.1885 15.6146 26.1885 16.317 25.4346L27.6728 13.8371C30.9507 10.4739 30.7751 4.90709 27.0874 1.77577Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ec2f0f193be78607e42a94186d26c44b.svg";
export { ForwardRef as ReactComponent };